import ReminderAPI from 'api/ReminderApi';

export const createReminders = (app_companies) => {
  return(dispatch: any) => {
    return ReminderAPI.createReminders(app_companies);
  }
}

export const updateReminders = (reminders: any) => {
  return { type: 'UPDATE_REMINDES', payload: reminders };
}



// WEBPACK FOOTER //
// ./src/actions/reminder/reminder.js